import { render, staticRenderFns } from "./ackusativobjekt.vue?vue&type=template&id=62add8e1&scoped=true"
import script from "./ackusativobjekt.vue?vue&type=script&lang=js"
export * from "./ackusativobjekt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62add8e1",
  null
  
)

export default component.exports